export default "__VITE_ASSET__BB76ozr2__"